import {Injectable} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FabricService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getFabric(id, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricColor(id, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public getFabricColorByQuery(id, query, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric/' + id + '/colors?' + query)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public getFabricDeleteColor(id,scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric/' + id + '/colors')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricItem(fabricId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/fabric/' + fabricId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageFabric(fabric, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/fabric/' + id, fabric)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/fabric/', fabric)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteFabric(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/fabric/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public readdFabric(id) {
    return this.http.put(environment.apiUrl + '/backoffice/fabric/' + id + '/reAdd', {id: id});
  }
  public setParentPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/fabric/colors/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
